import { AuthForm } from '@/modules/auth';

export default function Auth() {
  return <AuthForm />;
}
